import * as R from 'ramda';
import { ActionType } from '../../../core/redux/actionType';
import { AppState } from '../../../core/redux/appState';
import { Action } from 'redux';
import { Rater, RaterLevel } from './models';
import { Language } from '../../../localization/models';


type SaveEditedRaterAction = {
  type: ActionType.SaveEditedRater;
  projectId: number;
  participantId: number;
  raterId: number;
  email?: string;
  undelivered?: boolean;
  firstName?: string;
  lastName?: string;
  raterLevel?: RaterLevel;
  language?: Language;
};


export const saveEditedRaterAction = (
  projectId: number,
  participantId: number,
  raterId: number,
  email?: string,
  undelivered?: boolean,
  firstName?: string,
  lastName?: string,
  raterLevel?: RaterLevel,
  language?: Language,
): SaveEditedRaterAction => ({
  type:          ActionType.SaveEditedRater,
  projectId:     projectId,
  participantId: participantId,
  raterId:       raterId,
  email:         email,
  undelivered:   undelivered,
  firstName:     firstName,
  lastName:      lastName,
  raterLevel:    raterLevel,
  language:      language,
});

export const saveEditedRaterReducer = (state: AppState, incomingAction: Action): AppState => {
  if (incomingAction.type !== ActionType.SaveEditedRater) {
    return state;
  }

  const action = incomingAction as SaveEditedRaterAction;

  const rater = R.path<Rater>(['projectRaters', `${action.projectId}`, `${action.raterId}`], state);

  if (!rater) {
    return state;
  }

  let updatedRater = R.assoc('undeliveredEmail', false, rater);

  if (action.email) {
    updatedRater = R.assoc('email', action.email, updatedRater);
  }

  if (action.undelivered) {
    updatedRater = R.assoc('undelivered', action.undelivered, updatedRater);
  }

  if (action.firstName) {
    updatedRater = R.assoc('firstName', action.firstName, updatedRater);
  }

  if (action.lastName) {
    updatedRater = R.assoc('lastName', action.lastName, updatedRater);
  }

  if (action.raterLevel) {
    updatedRater = R.assoc('levelId', action.raterLevel.surveyLevelId, updatedRater);
    updatedRater = R.assoc('levelName', action.raterLevel.surveyLevelName ?? action.raterLevel.fullName, updatedRater);
  }

  if (action.language) {
    updatedRater = R.assoc('languageId', action.language.languageId, updatedRater);
    updatedRater = R.assoc('languageNameNative', action.language.nativeName, updatedRater);
    updatedRater = R.assoc('languageNameEnglish', action.language.englishName, updatedRater);
  }

  return R.assocPath(
    ['projectRaters', `${action.projectId}`, `${action.raterId}`],
    updatedRater,
    state,
  );
};
